// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"5e58aaf41b97918717d4","655":"6ff6f73f61d0bb0de95b"}[chunkId] + ".js";
};